import { render, staticRenderFns } from "./ImportSimpleDataDialog.vue?vue&type=template&id=6f1a7c9a&scoped=true"
import script from "./ImportSimpleDataDialog.vue?vue&type=script&lang=js"
export * from "./ImportSimpleDataDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportSimpleDataDialog.vue?vue&type=style&index=0&id=6f1a7c9a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1a7c9a",
  null
  
)

export default component.exports